import { render, staticRenderFns } from "./promos.vue?vue&type=template&id=34e80c1d"
import script from "./promos.vue?vue&type=script&lang=js"
export * from "./promos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports